import * as Yup from "yup";

export const validatorSchemaEmail = Yup.object().shape({
  email: Yup.string()
    .required("É necessário digitar um e-mail")
    .email("E-mail inválido"),
});

export const validatorSchemaToken = Yup.object().shape({
  token: Yup.string()
    .required("É necessário digitar um token")
    .length(6, "Token inválido"),
});
